// https://date-fns.org/docs/format
import format from 'date-fns/format'

export const formatDate = (date) => {
    if (!date) return ``
    if (typeof date.getMonth !== `function`) {
        date = new Date(date)
    }
    return format(date, `MMM d yyyy`)
}

export const formatDateShort = (date) => {
    if (!date) return ``
    if (typeof date.getMonth !== `function`) {
        date = new Date(date)
    }
    return format(date, `MM-dd-yyyy`)
}
export const formatDateTime = (date) => {
    if (!date) return ``
    if (typeof date.getMonth !== `function`) {
        date = new Date(date)
    }
    return format(date, `MM-dd-yyyy ppp`)
}

// convert a date object from BQ to a JS Date and return a date string or empty string
export const dateValueToDate = (dateObj) => {
    return dateObj && dateObj.value ? new Date(dateObj.value).toDateString() : ''
}
